module.exports = __webpack_public_path__ + "static/img/slide_6.9c1ff00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/slider/slide_6.png
// module id = knuL
// module chunks = 0